import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'content-loading-attedance-card',
    templateUrl: './content-loading-attedance-card.component.html',
    styleUrls: ['./content-loading-attedance-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentLoadingAttendanceCardComponent {

  constructor() { }

}